import './App.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import RequireAuth from "./utils/ProtectedRoute";
import Home from "./components/home/home";
import Base from "./components/layout/template/base";
import Error from "./components/error/error";
import Course from "./components/pages/course";
import Pool from "./components/pages/pool";
import Login from "./components/pages/login";
import Password from "./components/pages/password";
import Registration from "./components/pages/registration";
import RegistrationSent from "./components/pages/registrationSent";
import RegistrationDone from "./components/pages/registrationDone";
import Booking from "./components/pages/booking";
import Cart from "./components/pages/cart";
import Address from "./components/pages/address";
import ErrorPayment from "./components/error/errorPayment";
import Account from "./components/pages/account";
import Historical from "./components/pages/historical";
import Order from "./components/pages/order";
import Participant from "./components/pages/participant";
import Edit from "./components/pages/edit";
import AdminDashboard from "./components/pages_admin/adminDashboard";
import AdminCourses from "./components/pages_admin/adminCourses";
import AdminEditCourse from "./components/pages_admin/adminEditCourse";
import AdminDetailCourse from "./components/pages_admin/adminDetailCourse";
import AdminOrders from "./components/pages_admin/adminOrders";
import AdminDetailOrder from "./components/pages_admin/adminDetailOrder";
import AdminRoute from "./utils/AdminRoute";
import AdminCoupons from "./components/pages_admin/adminCoupons";
import AdminEditCoupon from "./components/pages_admin/adminEditCoupon";
import AdminDetailCoupon from "./components/pages_admin/adminDetailCoupon";
import AppRoute from "./utils/AppRoute";
import {AppProvider} from "./utils/AppContext";
import AdminReport from "./components/pages_admin/adminReports";
import AdminLevels from "./components/pages_admin/adminLevels";
import AdminPools from "./components/pages_admin/adminPools";

function App() {
    return (

        <BrowserRouter>
            <AppProvider>
            <Routes>
                <Route path='/shop' element={<Base/>}>
                    <Route index={true} element={<Home/>}/>
                    <Route path={AppRoute.COURSE} element={<Course/>}/>
                    <Route path={AppRoute.POOL} element={<Pool/>}/>

                    <Route path={AppRoute.LOGIN} element={<Login/>}/>
                    <Route path={AppRoute.PASSWORD} element={<Password/>}/>
                    <Route path={AppRoute.REGISTRATION} element={<Registration/>}/>
                    <Route path={AppRoute.REGISTRATION_SENT} element={<RegistrationSent/>}/>
                    <Route path={AppRoute.REGISTRATION_CONFIRM} element={<RegistrationDone/>}/>

                    <Route path={AppRoute.BOOKING} element={<RequireAuth><Booking/></RequireAuth>}/>
                    <Route path={AppRoute.CART} element={<RequireAuth><Cart/></RequireAuth>}/>
                    <Route path={AppRoute.ADDRESS} element={<RequireAuth><Address/></RequireAuth>}/>
                    <Route path={AppRoute.PAYMENT_ERROR} element={<RequireAuth><ErrorPayment/></RequireAuth>}/>
                    <Route path={AppRoute.ACCOUNT} element={<RequireAuth><Account/></RequireAuth>}/>
                    <Route path={AppRoute.HISTORY} element={<RequireAuth><Historical/></RequireAuth>}/>
                    <Route path={AppRoute.ORDER} element={<RequireAuth><Order/></RequireAuth>}/>
                    <Route path={AppRoute.PARTICIPANT} element={<RequireAuth><Participant/></RequireAuth>}/>
                    <Route path={AppRoute.EDIT} element={<RequireAuth><Edit/></RequireAuth>}/>
                    <Route path={AppRoute.ERROR} element={<Error/>}/>

                    <Route path={AppRoute.ADMIN} element={<AdminRoute><AdminDashboard /></AdminRoute>} />
                    <Route path={AppRoute.ADMIN_COURSES} element={<AdminRoute><AdminCourses /></AdminRoute>} />
                    <Route path={AppRoute.ADMIN_LEVELS} element={<AdminRoute><AdminLevels /></AdminRoute>} />
                    <Route path={AppRoute.ADMIN_POOLS} element={<AdminRoute><AdminPools /></AdminRoute>} />
                    <Route path={AppRoute.ADMIN_EDIT_COURSE} element={<AdminRoute><AdminEditCourse /></AdminRoute>} />
                    <Route path={AppRoute.ADMIN_DETAIL_COURSES} element={<AdminRoute><AdminDetailCourse /></AdminRoute>} />
                    <Route path={AppRoute.ADMIN_ORDERS} element={<AdminRoute><AdminOrders /></AdminRoute>} />
                    <Route path={AppRoute.ADMIN_DETAIL_ORDERS} element={<AdminRoute><AdminDetailOrder /></AdminRoute>} />
                    <Route path={AppRoute.ADMIN_COUPONS} element={<AdminRoute><AdminCoupons /></AdminRoute>} />
                    <Route path={AppRoute.ADMIN_EDIT_COUPON} element={<AdminRoute><AdminEditCoupon /></AdminRoute>} />
                    <Route path={AppRoute.ADMIN_DETAIL_COUPON} element={<AdminRoute><AdminDetailCoupon /></AdminRoute>} />
                    <Route path={AppRoute.ADMIN_REPORT} element={<AdminRoute><AdminReport /></AdminRoute>} />



                </Route>
            </Routes>
            </AppProvider>
        </BrowserRouter>
    );
}

export default App;
